import RegisterView from './RegisterView'
import useRegister from './useRegister'

import Loading from 'pages/Loading'
import { useTranslation } from 'react-i18next'

export default function Register() {
  const {
    loading,
    validationComplete,
    hasError,
    companyData,
    referralCode,
    validationCode,
  } = useRegister()
  const { t } = useTranslation('register')

  // Mostrar loading mientras se está cargando o no se ha completado la validación
  if (loading || !validationComplete) {
    return <Loading />
  }

  // Mostrar error solo si hasError es explícitamente true
  if (hasError) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen px-4">
        <div className="text-center max-w-md">
          <h2 className="text-2xl font-bold mb-4">{t('error.title')}</h2>
          <p className="text-gray-600 mb-6">{t('error.message')}</p>
        </div>
      </div>
    )
  }

  // Si no hay error pero aún no hay companyData, seguir en loading
  if (!companyData) {
    return <Loading />
  }

  return (
    <RegisterView
      companyData={companyData}
      referralCode={referralCode}
      validationCode={validationCode}
    />
  )
}
